import React, {useEffect, useState} from 'react';
import {Checkbox, CircularProgress, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import WorkerService from '../../../../../../API/orders/job/WorkerService';
import JobService from '../../../../../../API/orders/job/JobService';
import WorkerUtil from '../../../../../../utils/orders/WorkerUtil';
import {
    technicalMapCardWorkersEmptySx,
    technicalMapCardWorkerNameSx,
    technicalMapCardWorkerRowSx,
    technicalMapCardWorkerValueCellSx,
} from './technicalMapCardStyles';

const TechnicalMapJobWorkersAccordion = ({
                                             jobId,
                                             expanded,
                                             disabled,
                                             setData,
                                             handleModalAlert,
                                         }) => {
    const [workers, setWorkers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!expanded || loaded) {
            return undefined;
        }

        let cancelled = false;
        setLoading(true);
        WorkerService.getAllByJobId(jobId)
            .then((response) => {
                if (!cancelled) {
                    setWorkers(response.data ?? []);
                    setLoaded(true);
                }
            })
            .catch((error) => {
                if (!cancelled) {
                    handleModalAlert(error);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [expanded, handleModalAlert, jobId, loaded]);

    useEffect(() => {
        setLoaded(false);
        setWorkers([]);
    }, [jobId]);

    const handleUnableCheckbox = (id, status) => {
        JobService.unableWorkerByJobsId(jobId, id, status)
            .then((response) => {
                const updatedJob = response.data;
                setData((prev) => prev.map((el) => (el.id === updatedJob.id ? updatedJob : el)));
                setWorkers((prev) => prev.map((el) => (el.id === id ? {...el, enabled: status} : el)));
                handleModalAlert('Данные изменены', 'success');
            })
            .catch((error) => {
                handleModalAlert(error);
            });
    };

    if (!expanded) {
        return null;
    }

    if (loading) {
        return (
            <Box sx={{display: 'flex', justifyContent: 'center', py: 2}}>
                <CircularProgress disableShrink size={28}/>
            </Box>
        );
    }

    if (workers.length === 0) {
        return (
            <Typography sx={technicalMapCardWorkersEmptySx}>
                Нет работников
            </Typography>
        );
    }

    return (
        <Box
            sx={{
                border: '1px solid #EAEBEA',
                borderRadius: '8px',
                overflow: 'hidden',
                opacity: disabled ? 0.5 : 1,
                pointerEvents: disabled ? 'none' : 'auto',
            }}
        >
            {workers.map((worker, index) => {
                const workerName = worker.workerTechnicalMap
                    ? WorkerUtil.convertWorker(worker.workerTechnicalMap)
                    : '—';

                return (
                    <Box
                        key={worker.id}
                        sx={{
                            ...technicalMapCardWorkerRowSx,
                            backgroundColor: index % 2 === 0 ? '#F5F6FA' : 'white',
                        }}
                    >
                        <Checkbox
                            checked={Boolean(worker.enabled)}
                            disabled={disabled}
                            onChange={() => handleUnableCheckbox(worker.id, !worker.enabled)}
                            sx={{
                                p: '4px',
                                '& .MuiSvgIcon-root': {fontSize: 20},
                            }}
                        />
                        <Box sx={{...technicalMapCardWorkerValueCellSx, flex: 1}}>
                            <Typography
                                title={workerName}
                                sx={technicalMapCardWorkerNameSx}
                            >
                                {workerName}
                            </Typography>
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
};

export default TechnicalMapJobWorkersAccordion;
